import React from 'react';
import { Routes, Route } from 'react-router-dom';

import logo from 'assets/logo.svg';

import { Reset } from './Reset';
import { SignUp } from './SignUp';
import { Login } from './Login';

export const AuthWrapper = () => {
  return (
    <div className="auth-wrapper min-h-screen flex items-center justify-center bg-ui-bg px-4 py-10">
      <div className="w-full max-w-[420px] rounded-chip border border-ui-hair-2 bg-ui-elevated px-6 py-8 sm:px-10 sm:py-10 text-sm text-ui-3">
        <img src={logo} alt="" width={52} className="mx-auto mb-4" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<SignUp />} />
          <Route path="/reset" element={<Reset />} />
        </Routes>
      </div>
    </div>
  );
}
